import { CustomizationEntry } from "../types";

export enum AvatarCategory {
    Behavior = 'Behavior',
    Appearance = 'Appearance',
    Header = 'Header'
}

export enum AvatarSubCategory {
    Common = 'Common',
    Avatar = 'Avatar',
    Controls = 'Controls',
}

export type AvatarCustomizationEntry = CustomizationEntry<AvatarCategory, AvatarSubCategory>;
